exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-view[data-v-27d7c71c]{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;background:#fff;margin-top:4em}.column[data-v-27d7c71c],.table-view[data-v-27d7c71c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.column[data-v-27d7c71c]{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.tables[data-v-27d7c71c]{margin-bottom:1rem}.tables[data-v-27d7c71c]:nth-child(2n){padding-left:.5em}.tables[data-v-27d7c71c]:nth-child(odd){padding-right:.5em}", ""]);

// exports
